import { ErrorBoundary, HomeLayout, Layout } from '@/components';
import HomePage from '@/pages';
import SavingsPage from '@/pages/savings';
import SavingsSymbolPage from '@/pages/savings/symbol';
import SparkLiquidityLayerPage from '@/pages/spark-liquidity-layer';
import SLLActivity from '@/pages/spark-liquidity-layer/activity';
import BAAssetsPage from '@/pages/spark-liquidity-layer/all-assets';
import SLLAllocationActivityPage from '@/pages/spark-liquidity-layer/allocation-activity';
import AssetsPage from '@/pages/spark-liquidity-layer/assets';
import SLLNetworkPage from '@/pages/spark-liquidity-layer/network';
import SLLNetworkActivityPage from '@/pages/spark-liquidity-layer/network/activity';
import SLLNetworkAssetsPage from '@/pages/spark-liquidity-layer/network/assets';
import PSM3Page from '@/pages/spark-liquidity-layer/psm3';
import PSM3ActivityPage from '@/pages/spark-liquidity-layer/psm3/activity';
import ALMProxyPage from '@/pages/spark-liquidity-layer/tokens';
import ActivityTokenPage from '@/pages/spark-liquidity-layer/tokens/activity';
import SparkLendPage from '@/pages/sparklend';
import SPKPage from '@/pages/spk';
import AirdropLeaderboardPage from '@/pages/spk/airdrop';
import StakingWalletsPage from '@/pages/spk/staking';
import SparkTokenPage from '@/pages/spk/token';
import SparkTokenActivityPage from '@/pages/spk/token/activity';
import SparkTokenHoldersPage from '@/pages/spk/token/holders';
import SparkTokenHolderPage from '@/pages/spk/token/holders/holder';
// import SparkTokenPage from '@/pages/spark-token' ;

import { createBrowserRouter } from 'react-router';

const router = createBrowserRouter([
  {
    errorElement: (
      <Layout>
        <ErrorBoundary />
      </Layout>
    ),
    children: [
      {
        element: <HomeLayout />,
        children: [
          {
            path: '/',
            element: <HomePage />
          }
        ]
      },
      {
        element: <Layout />,
        children: [
          {
            path: '/',
            element: <HomePage />
          },
          {
            path: '/spark-liquidity-layer',
            element: <SparkLiquidityLayerPage />
          },
          {
            path: '/spark-liquidity-layer/activity',
            element: <SLLActivity />
          },
          {
            path: '/spark-liquidity-layer/allocation-activity',
            element: <SLLAllocationActivityPage />
          },
          {
            path: '/spark-liquidity-layer/assets',
            element: <AssetsPage />
          },
          {
            path: '/spark-liquidity-layer/all-assets',
            element: <BAAssetsPage />
          },
          {
            path: '/spark-liquidity-layer/:network',
            element: <SLLNetworkPage />
          },
          {
            path: '/spark-liquidity-layer/:network/assets',
            element: <SLLNetworkAssetsPage />
          },
          {
            path: '/spark-liquidity-layer/:network/activity',
            element: <SLLNetworkActivityPage />
          },
          {
            path: '/spark-liquidity-layer/:network/psm3',
            element: <PSM3Page />
          },
          {
            path: '/spark-liquidity-layer/:network/psm3/activity',
            element: <PSM3ActivityPage />
          },
          {
            path: 'spark-liquidity-layer/:network/:address/:tokenAddress',
            element: <ALMProxyPage />
          },
          {
            path: 'spark-liquidity-layer/:network/:address/:tokenAddress/activity',
            element: <ActivityTokenPage />
          },
          {
            path: '/savings',
            element: <SavingsPage />
          },
          {
            path: '/savings/:symbol',
            element: <SavingsSymbolPage />
          },
          {
            path: '/spk',
            element: <SPKPage />
          },
          {
            path: '/spk/airdrop',
            element: <AirdropLeaderboardPage />
          },
          {
            path: '/spk/token',
            element: <SparkTokenPage />
          },
          {
            path: '/spk/token/activity',
            element: <SparkTokenActivityPage />
          },
          {
            path: '/spk/token/holders',
            element: <SparkTokenHoldersPage />
          },
          {
            path: '/spk/token/holders/:wallet_address',
            element: <SparkTokenHolderPage />
          },
          {
            path: '/sparklend',
            element: <SparkLendPage />
          },
          {
            path: '/spk/staking',
            element: <StakingWalletsPage />
          }
        ]
      }
    ]
  }
]);

export default router;
